export default __webpack_public_path__ + "resourceRegister.html";